// extracted by mini-css-extract-plugin
export var childrenContainer = "_bf-0";
export var virtualScrollArea = "_bf-1";